export default "__VITE_ASSET__DJZvoubJ__"